import { render, staticRenderFns } from "./AItalk4.vue?vue&type=template&id=afbb13c6&"
import script from "./AItalk4.vue?vue&type=script&lang=js&"
export * from "./AItalk4.vue?vue&type=script&lang=js&"
import style0 from "./AItalk4.vue?vue&type=style&index=0&id=afbb13c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports